module.exports = __webpack_public_path__ + "media/images/icon/navigation/explore-active-8b4259751858d9d630771799ed0bdbb4.svg";